module.exports = "./img/e174869f81ec247e892f65bd172c796d.jpg";